import { useMemo } from 'react';
import { useUtils } from '../../../context/UtilsContext';

/** Event type for template summary/list APIs (matches session `food_add_coach_template` when present). */
export const TEMPLATE_SUMMARIES_EVENT_ID = '538aa894-3799-4ccc-a271-80d9d0957ce4';

export function useTemplateEventTypeId() {
  const { sessionUtils } = useUtils();
  return useMemo(
    () =>
      sessionUtils?.event_types?.[0]?.event_types?.find(
        (x) => x.description === 'food_add_coach_template'
      )?.id ?? null,
    [sessionUtils]
  );
}

export function resolveRecipeEventTypeId(sessionUtils) {
  if (!sessionUtils?.event_types) return null;

  const types = sessionUtils.event_types.flatMap((g) => g.event_types || []);

  const exact =
    types.find((t) => t.description === 'fetch_recipes') ??
    types.find((t) => t.description === 'modify_recipes');
  if (exact) return exact.id;

  // Legacy fallback — matches pre-refactor behavior so Recipes page loads
  const fuzzy = types.find((evt) => {
    const d = evt.description?.toLowerCase() ?? '';
    return d.includes('recipe') || d.includes('diet') || d.includes('food');
  });
  return fuzzy?.id ?? types[0]?.id ?? null;
}

export function useRecipeEventTypeId() {
  const { sessionUtils } = useUtils();
  return useMemo(() => resolveRecipeEventTypeId(sessionUtils), [sessionUtils]);
}
